import { createReducer, on } from '@ngrx/store';
import { onLoadableError, onLoadableLoad, onLoadableSuccess } from '../../models/loadable';
import { AudioDeviceActions } from './audio-device.actions';
import { initialAudioDeviceState, initialSiteDevicesState } from './audio-device.state';
import { UserActions } from '../user/user.actions';

export const audioDeviceReducer = createReducer(
  initialAudioDeviceState,

  on(AudioDeviceActions.loadBySite, (state, { siteId, force }) => {
    const existing = state.devicesBySite[siteId] ?? initialSiteDevicesState();
    if (!force && existing.success) {
      return state;
    }
    return {
      ...state,
      devicesBySite: {
        ...state.devicesBySite,
        [siteId]: onLoadableLoad(existing),
      },
    };
  }),
  on(AudioDeviceActions.loadBySiteSuccess, (state, { siteId, devices }) => ({
    ...state,
    devicesBySite: {
      ...state.devicesBySite,
      [siteId]: onLoadableSuccess({ ...(state.devicesBySite[siteId] ?? initialSiteDevicesState()), items: devices }),
    },
  })),
  on(AudioDeviceActions.loadBySiteFailure, (state, { siteId, error }) => ({
    ...state,
    devicesBySite: {
      ...state.devicesBySite,
      [siteId]: onLoadableError(state.devicesBySite[siteId] ?? initialSiteDevicesState(), error),
    },
  })),

  on(AudioDeviceActions.createDeviceSuccess, (state, { siteId, devices }) => ({
    ...state,
    devicesBySite: {
      ...state.devicesBySite,
      [siteId]: onLoadableSuccess({
        ...(state.devicesBySite[siteId] ?? initialSiteDevicesState()),
        items: [...(state.devicesBySite[siteId]?.items ?? []), ...devices],
      }),
    },
  })),

  on(AudioDeviceActions.updateDeviceSuccess, (state, { device }) => {
    const siteId = device.site_id;
    const siteDevices = state.devicesBySite[siteId];
    if (!siteDevices) {
      return state;
    }
    return {
      ...state,
      devicesBySite: {
        ...state.devicesBySite,
        [siteId]: onLoadableSuccess({
          ...siteDevices,
          items: siteDevices.items.map((d) => (d.id === device.id ? device : d)),
        }),
      },
    };
  }),

  on(AudioDeviceActions.deleteDeviceSuccess, (state, { siteId, id }) => {
    const siteDevices = state.devicesBySite[siteId];
    if (!siteDevices) {
      return state;
    }
    return {
      ...state,
      devicesBySite: {
        ...state.devicesBySite,
        [siteId]: onLoadableSuccess({
          ...siteDevices,
          items: siteDevices.items.filter((d) => d.id !== id),
        }),
      },
    };
  }),

  on(UserActions.logout, () => ({ ...initialAudioDeviceState })),
);
